module.exports = __webpack_public_path__ + "static/media/craps.18692ac3.svg";